<template>
  <router-link
    append
    :to="{ params }"
    :class="classes">
    {{ omitHashtag ? '' : '#' }}{{ tag }}
  </router-link>
</template>

<script>
export default {
  name: 'TagLink',
  props: ['classes', 'omitHashtag', 'tag'],
  computed: {
    params() {
      return { tag: this.url }
    },
    url() {
      return this.tag.replace('#', '')
    }
  }
};
</script>

<style scoped lang="scss">

</style>
